import React from 'react';
import { Link } from 'react-router-dom';

const RelatedPosts = ({ posts, currentSlug }) => {
  const related = posts?.filter(p => p?.slug !== currentSlug)?.slice(0, 3);

  if (!related?.length) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr)?.toLocaleDateString('nb-NO', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <section style={{ marginTop: '80px', paddingTop: '48px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '36px' }}>
        <div style={{ width: '4px', height: '36px', background: '#3B6FD4' }} />
        <h2 style={{ fontFamily: 'Impact, sans-serif', fontSize: '1.8rem', fontWeight: 900, color: '#EEF0F2', margin: 0, textTransform: 'uppercase', letterSpacing: '-0.02em' }}>RELATERTE SAKER</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '24px' }}>
        {related?.map((post, i) => (
          <Link
            key={post?.id}
            to={`/individual-article-detail-view?slug=${post?.slug}`}
            style={{ textDecoration: 'none' }}
          >
            <div
              style={{
                background: '#0D1520',
                border: '1px solid rgba(255,255,255,0.07)',
                overflow: 'hidden',
                transform: `rotate(${i % 2 === 0 ? '-0.4deg' : '0.4deg'})`,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'rotate(0deg) translateY(-4px)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = `rotate(${i % 2 === 0 ? '-0.4deg' : '0.4deg'})`; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div style={{ height: '160px', overflow: 'hidden' }}>
                <img
                  src={post?.hero_image || 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=400&h=200&fit=crop'}
                  alt={post?.hero_image_alt || post?.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div style={{ padding: '16px' }}>
                <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.65rem', color: 'rgba(238,240,242,0.4)', margin: '0 0 8px' }}>{formatDate(post?.published_at)}</p>
                <h3 style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9rem', fontWeight: 800, color: '#EEF0F2', margin: '0 0 8px', lineHeight: 1.3, letterSpacing: '-0.01em' }}>{post?.title}</h3>
                <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.7rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Les mer →</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;
